module.exports = __webpack_public_path__ + "static/img/pic02.f0c869d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/images/pic02.jpg
// module id = tUSB
// module chunks = 2